const hydrate = async () => {
  const containers = document.querySelectorAll(".editor-content");
  for (const container of containers) {
    const scripts = Array.from(
      container.querySelectorAll("script:not([hydrated])")
    );
    for (const oldScript of scripts) {
      const newScript = document.createElement("script");
      for (const attr of Array.from(oldScript.attributes)) {
        newScript.setAttribute(attr.name, attr.value);
      }
      newScript.setAttribute("hydrated", "true");
      newScript.textContent = oldScript.textContent ?? "";
      const replace = () => oldScript.parentNode?.replaceChild(newScript, oldScript);
      if (oldScript.src) {
        if (!newScript.type || newScript.type.toLowerCase() !== "module") {
          newScript.async = false;
        }
        replace();
        await new Promise((resolve, reject) => {
          newScript.addEventListener("load", () => resolve(), { once: true });
          newScript.addEventListener(
            "error",
            () => reject(new Error(`Failed to load ${newScript.src}`)),
            { once: true }
          );
        });
      } else {
        newScript.textContent = oldScript.textContent ?? "";
        replace();
      }
    }
  }
  return true;
};
export {
  hydrate
};
//# sourceMappingURL=hydration.js.map
